import { render, staticRenderFns } from "./service-comment.vue?vue&type=template&id=136ffd2d&scoped=true&"
import script from "./service-comment.vue?vue&type=script&lang=js&"
export * from "./service-comment.vue?vue&type=script&lang=js&"
import style0 from "./service-comment.vue?vue&type=style&index=0&id=136ffd2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ffd2d",
  null
  
)

export default component.exports